export const ORIGINAL_SHAPES = {
  circle: { tag: 'circle' },
  square: { tag: 'rect' },
  diamond: { tag: 'polygon', points: '12,3 21,12 12,21 3,12' },
  triangle: { tag: 'polygon', points: '12,3 22,21 2,21' },
  pentagon: { tag: 'polygon', points: '12,2 22,8.5 18,20 6,20 2,8.5' },
  hexagon: { tag: 'polygon', points: '12,2 21,7 21,17 12,22 3,17 3,7' },
  star: { tag: 'polygon', points: '12,2 15,9 22,9 16,14 18,21 12,17 6,21 8,14 2,9 9,9' },
  triangle_down: { tag: 'polygon', points: '2,3 22,3 12,21' },
  octagon: { tag: 'polygon', points: '8,2 16,2 22,8 22,16 16,22 8,22 2,16 2,8' },
};

export const MATH_SHAPES = {
  plus: { tag: 'path', d: 'M11,11 V5 h2 v6 h6 v2 h-6 v6 h-2 v-6 h-6 v-2 Z' },
  minus: { tag: 'path', d: 'M5,11 h14 v2 h-14 Z' },
  times: { tag: 'path', d: 'M13.41,12 l4.29,-4.29 l-1.41,-1.41 l-4.29,4.29 l-4.29,-4.29 l-1.41,1.41 l4.29,4.29 l-4.29,4.29 l1.41,1.41 l4.29,-4.29 l4.29,4.29 l1.41,-1.41 Z' },
  divide: { tag: 'path', d: 'M19,13 H5 v-2 h14 v2 z M12,7 a1.5,1.5 0 1 1 0,-3 1.5,1.5 0 0 1 0,3 z M12,20 a1.5,1.5 0 1 1 0,-3 1.5,1.5 0 0 1 0,3 z' },
  equals: { tag: 'path', d: 'M19,10 H5 V8 h14 v2 z M19,16 H5 v-2 h14 v2 z' },
};

export const SHAPES = {
  ...ORIGINAL_SHAPES,
  ...MATH_SHAPES,
};

export const DIRECTION_SIDES = {
  h: {
    top: false,
    right: true,
    bottom: false,
    left: true,
  },
  v: {
    top: true,
    right: false,
    bottom: true,
    left: false,
  },
  tr: {
    top: true,
    right: true,
    bottom: false,
    left: false,
  },
  tl: {
    top: true,
    right: false,
    bottom: false,
    left: true,
  },
  br: {
    top: false,
    right: true,
    bottom: true,
    left: false,
  },
  bl: {
    top: false,
    right: false,
    bottom: true,
    left: true,
  },
};

export const PATH_WEIGHTS = {
  thin: 1.2,
  normal: 2,
  bold: 4,
};
